import { render, staticRenderFns } from "./OfficeTable.vue?vue&type=template&id=df563740&scoped=true&"
import script from "./OfficeTable.vue?vue&type=script&lang=js&"
export * from "./OfficeTable.vue?vue&type=script&lang=js&"
import style0 from "./OfficeTable.vue?vue&type=style&index=0&id=df563740&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df563740",
  null
  
)

export default component.exports